import React, { useState } from "react";
import "./index.scss";
import FaqAnswerTypewriter from "../faqAnswerTypewriter";

const FAQ = () => {
  const [faqs, setFaqs] = useState([
    {
      question: "Dans quels délais intervenez-vous ?",
      answer:
        "Rééponse sous 24h pour toute demande. Intervention possible dans la semaine selon urgence et disponibilités.",
      open: true,
    },
    {
      question: "Quels sont vos secteurs de prédilection ?",
      answer:
        "Nootre cabinet de conseil excelle dans la Banque/Finance, l'E-Commerce, l'Assurance, la Logistique et l'Automobile.",
      open: false,
    },
    {
      question: "Comment garantissez-vous la qualité ?",
      answer:
        "Prrocessus QA rigoureux, consultants seniors certifiés, et engagement de résultats sur tous nos projets",
      open: false,
    },
    {
      question: "Travaillez-vous avec des PME ?",
      answer:
        "Abbsolument ! Notre cabinet de conseil s'adapte à toutes les tailles d'entreprise, de la start-up au grand groupe.",
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h1 className="faq-title mt-3">Questions Fréquemment Posées</h1>
        </div>
        <div className="faqs">
          {faqs.map((faq, index) => (
            <div
              className={"faq " + (faq.open ? "open" : "")}
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">{faq.question}</div>
              <hr className="faq-answer1" />
              {faq.open && (
                <FaqAnswerTypewriter text={faq.answer} isActive={faq.open} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
